"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SdkLanguage = void 0;
var _tsRes = require("ts-res"),
  _utilities = require("../../utilities");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var SdkLanguage = /*#__PURE__*/function () {
  function SdkLanguage(a) {
    _classCallCheck(this, SdkLanguage);
    var b = a.sdkLanguage,
      c = a.version,
      d = a.versionMatchType;
    _defineProperty(this, "sdkLanguage", void 0), _defineProperty(this, "conditionValue", void 0), _defineProperty(this, "versionMatchType", void 0), this.sdkLanguage = b, this.conditionValue = c, this.versionMatchType = d;
  }
  return _createClass(SdkLanguage, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.sdkInfo;
      return this.checkCondition(b);
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      var b = a.type,
        c = a.version;
      if (!this.sdkLanguage) return (0, _tsRes.Ok)(!1);
      if ("string" != typeof this.conditionValue) return (0, _tsRes.Ok)(b === this.sdkLanguage);
      if (!this.versionMatchType) return (0, _tsRes.Ok)(!1);
      var d = _utilities.Utilities.compareSemVer({
        version: c,
        compareVersion: this.conditionValue,
        operator: this.versionMatchType
      });
      return d.ok ? (0, _tsRes.Ok)(b === this.sdkLanguage && d.data) : (0, _tsRes.Err)(d.error);
    }
  }]);
}();
exports.SdkLanguage = SdkLanguage;